import { IsString, IsNotEmpty, Length, IsNumberString } from 'class-validator';

import { t } from '@vk-hr-tek/core/translations';

import { UNEP_KONTUR_CODE_LENGTH } from '@app/constants';

const notEmptyOptions = {
  message: 'Обязательное поле',
};

export class SignPolicyDto {
  @IsNotEmpty({
    ...notEmptyOptions,
    groups: ['code-verify'],
  })
  @IsString({
    groups: ['code-verify'],
  })
  @Length(UNEP_KONTUR_CODE_LENGTH, UNEP_KONTUR_CODE_LENGTH, {
    message: () => t('PopupSignUNEPKontur.Error.Code'),
    groups: ['code-verify'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: () => t('PopupSignUNEPKontur.Error.Code'),
      groups: ['code-verify'],
    },
  )
  code: string;
}
